import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Items from './items/pages/Items';
import MainNavigation from './shared/components/Navigation/MainNavigation';
import Auth from './auth/Auth';
import { AuthContext } from './shared/context/auth-context';
import Customers from './customer/pages/Customers';
import localforage from 'localforage';
import axios from 'axios';
import Inicio from './inicio/Inicio';
import Horas from './customer/pages/Horas';
import ReporteHoras from './horas/pages/ReporteHoras';

// Import session test utilities for development
if (process.env.NODE_ENV === 'development') {
  import('./test-session-timeout.js');
}

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState('');

  axios.defaults.baseURL = process.env.REACT_APP_BACKEND_BASE_URL;
  useEffect(() => {
    (async function () {
      try {
        // Check for new session structure first
        const userSession = await localforage.getItem('userSession');

        if (userSession) {
          // Check if session has expired
          const currentTime = new Date().getTime();
          const sessionAge = currentTime - userSession.loginTime;

          if (sessionAge > userSession.expiresIn) {
            // Session expired - clean up and logout
            console.log('Session expired after 24 hours');
            await localforage.removeItem('userSession');
            await localforage.removeItem('user'); // Clean up old format too
            setIsLoggedIn(false);
            setUser(null);
            return;
          }

          // Session is valid
          setIsLoggedIn(true);
          setUser(userSession.user);
          return;
        }

        // Fallback: check for old user format and migrate
        const legacyUser = await localforage.getItem('user');
        if (legacyUser) {
          // Migrate to new session format
          const sessionData = {
            user: legacyUser,
            loginTime: new Date().getTime(),
            expiresIn: 24 * 60 * 60 * 1000 // 24 hours
          };

          await localforage.setItem('userSession', sessionData);
          await localforage.removeItem('user'); // Remove old format
          setIsLoggedIn(true);
          setUser(legacyUser);
        }
      } catch (err) {
        console.log('Error checking session:', err);
      }
    })();
  }, []);

  const login = useCallback(() => {
    setIsLoggedIn(true);
  }, []);
  const logout = useCallback(() => {
    localforage.removeItem('userSession', (err) => {
      if (!err) {
        setUser(null);
        setIsLoggedIn(false);
      } else {
        console.log(err);
      }
    });
  }, []);

  let routes;

  if (isLoggedIn) {
    routes = (
      <Fragment>
        <Route path="/" element={<Inicio />}></Route>
        <Route path="/clientes" element={<Customers />}></Route>
        <Route path="/horas" element={<Horas />}></Route>
        <Route path="/items" element={<Items />}></Route>
        <Route path="/reporte-horas" element={<ReporteHoras />}></Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Fragment>
    );
  } else {
    routes = (
      <Fragment>
        <Route path="/auth" element={<Auth />}></Route>
        <Route path="*" element={<Navigate to="/auth" replace />} />
      </Fragment>
    );
  }
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
        <Router>
          <MainNavigation user={user} />
          <main>
            <Routes>{routes}</Routes>
          </main>
        </Router>
      </AuthContext.Provider>
    </GoogleOAuthProvider>
  );
};

export default App;
